// R1b-γ — Operations Documents tab. Rehomed from /admin/documents.
// Preserves sha256, uploader identity, public verify link.
import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import EmptyState from "../../../components/EmptyState";
import { FolderOpen } from "lucide-react";
import StatusChip from "../../../components/StatusChip";

export default function OperationsDocumentsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/documents").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);
  return (
    <div data-testid="operations-documents-body">
      <div className="mb-4">
        <div className="font-display font-semibold text-erf-dark text-lg">Document Control</div>
        <div className="text-xs font-nav text-erf-dark/60 mt-0.5" data-testid="documents-count">
          {rows === null ? "Loading…" : `${rows.length} document(s) · sha-256 versioned · public verify links available`}
        </div>
      </div>
      {rows !== null && rows.length === 0 && (
        <EmptyState icon={FolderOpen} title="No documents yet" subtitle="Upload from /admin/documents-legacy or attach documents to a contract or credential." />
      )}
      {rows !== null && rows.length > 0 && (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Filename</th>
                <th className="text-left px-3 py-2">Class</th>
                <th className="text-left px-3 py-2">Version</th>
                <th className="text-left px-3 py-2">SHA-256</th>
                <th className="text-left px-3 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((d) => (
                <tr key={d.id} className="border-t border-erf-borderCream/60" data-testid={`document-row-${d.id}`}>
                  <td className="px-3 py-2 font-nav font-semibold">{d.filename || d.title || "—"}</td>
                  <td className="px-3 py-2 mono text-[11px] uppercase">{d.classification || d.class || "—"}</td>
                  <td className="px-3 py-2 mono">{d.version || 1}</td>
                  <td className="px-3 py-2 mono text-[10px] text-erf-dark/60 truncate max-w-[180px]">{d.sha256 ? d.sha256.slice(0, 16) + "…" : "—"}</td>
                  <td className="px-3 py-2"><StatusChip status={d.status || "connected"} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
